// extracted by mini-css-extract-plugin
export default {"crLoadingOverlay":"CrLoadingOverlay_crLoadingOverlay__tQurj","opaque":"CrLoadingOverlay_opaque__y2NFf"};